import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=1c6c8156&scoped=true&functional=true"
import script from "./Tile.vue?vue&type=script&lang=js"
export * from "./Tile.vue?vue&type=script&lang=js"
import style0 from "./Tile.vue?vue&type=style&index=0&id=1c6c8156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1c6c8156",
  null
  
)

export default component.exports